import { TooltipClasses, Theme } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';

export const MUI_TOOLTIP_OVERRIDES: Partial<
  OverridesStyleRules<keyof TooltipClasses, 'MuiTooltip', Theme>
> = {
  tooltip: ({ theme }) => ({
    maxHeight: theme.spacing(20),
    overflow: 'auto',
  }),
};
